import { makeStyles, Text, tokens } from '@fluentui/react-components';
import { ReactNode } from 'react';

const useStyles = makeStyles({
    section: {
        padding: '26px 30px',
        scrollMarginTop: '16px',
        ':not(:first-child)': {
            borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
        },
    },
    head: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '6px',
    },
    icon: {
        width: '34px',
        height: '34px',
        borderRadius: '9px',
        flex: 'none',
        backgroundColor: tokens.colorBrandBackground2,
        color: tokens.colorBrandForeground1,
        display: 'grid',
        placeItems: 'center',
        fontSize: '19px',
    },
    title: {
        fontSize: '18px',
        fontWeight: tokens.fontWeightBold,
        letterSpacing: '-0.01em',
    },
    desc: {
        fontSize: '13.5px',
        color: tokens.colorNeutralForeground2,
        margin: '0 0 22px 46px',
    },
});

interface SectionShellProps {
    id: string;
    icon: ReactNode;
    title: string;
    description: string;
    children: ReactNode;
}

/** One stacked section in the single-page form: head (icon + title + desc) + body. */
const SectionShell = ({ id, icon, title, description, children }: SectionShellProps) => {
    const styles = useStyles();
    return (
        <section id={id} className={styles.section} aria-label={title}>
            <div className={styles.head}>
                <span className={styles.icon} aria-hidden>
                    {icon}
                </span>
                <Text className={styles.title}>{title}</Text>
            </div>
            <p className={styles.desc}>{description}</p>
            {children}
        </section>
    );
};

export default SectionShell;
